/**
 * Shared form validators for consistent validation across the app.
 */

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[\d\s+()-]{8,20}$/;

export const validators = {
  required: (value, fieldName = 'This field') => {
    const v = typeof value === 'string' ? value.trim() : value;
    if (v === undefined || v === null || v === '') return `${fieldName} is required.`;
    return null;
  },

  email: (value) => {
    if (!value || !value.trim()) return null;
    if (!EMAIL_REGEX.test(value.trim())) return 'Please enter a valid email address.';
    return null;
  },

  phone: (value) => {
    if (!value || !value.trim()) return null;
    const cleaned = value.trim();
    if (!PHONE_REGEX.test(cleaned) || cleaned.replace(/\D/g, '').length < 8) {
      return 'Please enter a valid phone number (at least 8 digits).';
    }
    return null;
  },

  minLength: (value, min, fieldName = 'Field') => {
    if (!value) return null;
    if (String(value).length < min) return `${fieldName} must be at least ${min} characters.`;
    return null;
  },

  maxLength: (value, max, fieldName = 'Field') => {
    if (!value) return null;
    if (String(value).length > max) return `${fieldName} must be at most ${max} characters.`;
    return null;
  },

  dateNotInFuture: (dateStr, fieldName = 'Date') => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return `Invalid ${fieldName}.`;
    if (d > new Date()) return `${fieldName} cannot be in the future.`;
    return null;
  },
};

/**
 * Run multiple validators; returns first error message or null.
 */
export function validate(value, ...fns) {
  for (const fn of fns) {
    const err = typeof fn === 'function' ? fn(value) : null;
    if (err) return err;
  }
  return null;
}

export default validators;
